var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-heading',[_vm._v("Generic.Pages.functional")]),_c('doc-text',[_vm._v(_vm._s(`${_vm.namespace}.${_vm.page}.functional.desc`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }